import { render, staticRenderFns } from "./ClrmToolbarPrimary.vue?vue&type=template&id=4316d990&"
import script from "./ClrmToolbarPrimary.vue?vue&type=script&lang=js&"
export * from "./ClrmToolbarPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports